<template>
  <div>
    <vs-card>
      <b-row>
        <b-col>
          <v-select
            v-model="secilenSube"
            :options="subeList"
            placeholder="Şube seçiniz"
            style=""
            @input="smsTopluListe()"
          >
          </v-select>
        </b-col>
        <b-col>
          <b-form-input
            v-model="arananDeger"
            @keyup.enter="smsTopluListe"
            id="smallInput"
            placeholder="Arama..."
          />
        </b-col>
        <b-col cols="4">
          <vs-textarea label="Mesajınız" v-model="smsTexti" />
        </b-col>
        <b-col cols="2">
          <vs-button
            style="border-radius: 5px"
            @click="smsGonder()"
            type="gradient"
            >Sms Gönder</vs-button
          >
        </b-col>
      </b-row>
    </vs-card>
    <vs-card>
      <ag-grid-vue
        style="width: 100%; height: 400px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="listSmsGonderilecekler"
        :localeText="localeText"
        @grid-ready="onGridReady"
        @first-data-rendered="onFirstDataRendered"
        :rowSelection="rowSelection"
        @selection-changed="onSelectionChanged"
      >
      </ag-grid-vue>
    </vs-card>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import state from "../../store/state";
import Store from "../../store/store";
import vSelect from "vue-select";
export default {
  data() {
    return {
      smsTexti: "",
      telNo: [],
      arananDeger: "",
      secilenSube: "",
      subeList: [],
      listSmsGonderilecekler: [],
      rowSelection: null,
      localeText: null,
      columnDefs: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
    };
  },
  methods: {
    onSelectionChanged() {
      var selectedRows = this.gridApi.getSelectedRows();
      this.telNo = [...new Set(selectedRows.map((x) => x.telNo))];
    },
    smsGonder() {
      var vm = this;
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.telNo.length == 0) {
        vs.notify({
          title: "Sms Gönderim",
          text: "Herhangi bir seçim yapmadınız.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else if (vm.smsTexti == "") {
        vs.notify({
          title: "Sms Gönderim",
          text: "Mesaj alanı boş olamaz.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        const args = {
          token: Store.state.tokenId,
          gsm: vm.telNo.toString(),
          mesaj: vm.smsTexti,
        };
        console.log(args);

        soap.createClient(url, function (err, client) {
          client.topluSmsGonder(args, function (err, result) {
            if (result.topluSmsGonderResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            } else {
              vm.veriler = JSON.parse(result.topluSmsGonderResult);

              console.log(vm.veriler);
            }
          });
        });
      }
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    smsTopluListe() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        bolge: "",
        employId: vm.secilenSube,
        aranan: vm.arananDeger,
        size: "",
      };

      console.log(args);
      soap.createClient(url, function (err, client) {
        client.smsTopluListe(args, function (err, result) {
          if (result.smsTopluListeResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          } else {
            vm.veriler = JSON.parse(result.smsTopluListeResult);
            vm.listSmsGonderilecekler = vm.veriler.jsonData;
            console.log(vm.listSmsGonderilecekler);
            vm.subeList = [
              ...new Set(vm.listSmsGonderilecekler.map((x) => x.magazaKodu)),
            ];
            console.log(vm.subeList);
          }
        });
      });
    },
  },
  created() {
    this.rowSelection = "multiple";
    this.localeText = this.$store.state.uzum.AG_GRID_LOCALE_EN;
    this.smsTopluListe();
  },
  components: {
    AgGridVue,
    "v-select": vSelect,
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 20,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
      },
      {
        headerName: "Sipariş No",
        field: "orderNumber",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Müşteri Ad Soyad",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "shipFirstName",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Mağaza Kodu",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "magazaKodu",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Telefon Numarası",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "telNo",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
     
    ];
  },
};
</script>